var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"footer-props":{
      'items-per-page-text': 'Datensätze pro Seite',
      'items-per-page-all-text': 'Alle',
      'page-text': '{0}-{1} von {2}'
    },"headers":_vm.headers,"items":_vm.orders,"items-per-page":10,"height":500},scopedSlots:_vm._u([{key:"item.name",fn:function(ref){
    var item = ref.item;
return [_c('span',{domProps:{"innerHTML":_vm._s(item.name)}})]}},{key:"item.sheetAmount",fn:function(ref){
    var item = ref.item;
return [_c('span',{domProps:{"innerHTML":_vm._s(item.sheetAmount)}})]}},{key:"item.weight",fn:function(ref){
    var item = ref.item;
return [_c('span',{domProps:{"innerHTML":_vm._s(item.weight)}})]}},{key:"item.fullBatches",fn:function(ref){
    var item = ref.item;
return [_c('span',{domProps:{"innerHTML":_vm._s(item.fullBatches)}})]}},{key:"item.partialBatches",fn:function(ref){
    var item = ref.item;
return [_c('span',{domProps:{"innerHTML":_vm._s(item.partialBatches)}})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }